import { useState } from "react";
import { updateCampaigns, underScoreCaseToCamelCase, cellSpinnerHandler, parseInternationalizedValue } from "@ts/utils";
import { showToast } from "@ts/modals";
import * as Sentry from "@sentry/react";
import { ICustomCellRendererParams } from "@ts/common-types";
import { FaCheck, FaTrashAlt } from "react-icons/fa";
import { setUpdateGridData } from "@/ts/filters";

const UpdateCampaignPlacementCellRenderer = (
    params: ICustomCellRendererParams
) => {
    const [identifier] = useState<number>(params.data.sys_campaign_id);
    const [applyElementIdentifier] = useState<string>(
        `${params.column.colId}-${identifier}-applyBtnId`
    );
    const [cancelElementIdentifier] = useState<string>(
        `${params.column.colId}-${identifier}-cancelBtnId`
    );
    const [previous_value] = useState<number>(params.data[params.column.colId]);
    const [inputValue, setInputValue] = useState<number>(
        params.data[params.column.colId]
    );
    const [applyBtnStatus, setApplyBtnStatus] = useState<boolean>(false);
    const [cancelBtnStatus, setCancelBtnStatus] = useState<boolean>(false);
    const [loadingCheck,setLoadingCheck] = useState(false);
    const [loadingTrash,setLoadingTrash] = useState(false);

    const toggleChangeLock = function () {
        setApplyBtnStatus(applyBtnStatus === true ? false : true);
        setCancelBtnStatus(cancelBtnStatus === true ? false : true);
    };

    async function applyChange(isCancel=false) {
        toggleChangeLock();
        try {
            const valueToUpdate = isCancel ? previous_value : inputValue;
            const response = await updateCampaigns([
                {
                    campaignId: params.data.sys_campaign_id.toString(),
                    [underScoreCaseToCamelCase(
                        params.column.colId.replace("_placement", "")
                    )]: valueToUpdate,
                    attribute: [
                        underScoreCaseToCamelCase(
                            params.column.colId.replace("_placement", "")
                        ),
                    ],
                    state: "enabled",
                },
            ]);

            if (!response.status) {
                throw new Error(response.message);
            }

            showToast(
                "success",
                `Placement updated for campaign ${params.data.campaign_name}`
            );
            setUpdateGridData({
                params,
                value: valueToUpdate,
                isReduxState: true,
            });
        } catch (e) {
            console.error(e);
            setInputValue(previous_value);
            showToast(
                "danger",
                ` Error While Updating placement for ${
                    params.data.campaign_name
                } : ${(e as Error).message}`
            );
            Sentry.captureException(e);
        }
        toggleChangeLock();
    }

    const cancelBtnHandler = async function () {
        setInputValue(previous_value);
        await cellSpinnerHandler(setLoadingTrash, applyChange, true);
    };

    return (
        <>
            {params.node.rowPinned ? null : (
                <>
                    <div
                        id={`${params.column.colId}_update_btn_${identifier}`}
                        className="ag-cell-wrapper updateInput in"
                    >
                        <div className="input-group input-group-sm ">
                            <input
                                type="number"
                                value={inputValue}
                                id={`${params.column.colId}-update-field-${identifier}`}
                                className="form-control border border-primary "
                                data-id={identifier}
                                data-value={parseInternationalizedValue(inputValue)}
                                onChange={(e) =>
                                    setInputValue(parseInt(e.target.value))
                                }
                            />
                            <button
                                className="btn btn-light px-2 border-start border-top-0 border-bottom-0 border-primary"
                                value="Apply"
                                type="button"
                                disabled={loadingCheck}
                                onClick={(
                                    event: React.MouseEvent<
                                        HTMLButtonElement,
                                        MouseEvent
                                    >
                                ) => cellSpinnerHandler(setLoadingCheck, applyChange)}
                            >
                                {loadingCheck ? (
                                    <i
                                        className="spinner-border text-primary"
                                        style={{ width: "1em", height: "1em" }}
                                    />
                                ) : (
                                    <FaCheck
                                        id={applyElementIdentifier}
                                        className="text-primary"
                                            // value="Apply"
                                        type="button"
                                    />
                                )}
                            </button>
                            <button
                                className="btn btn-light px-2"
                                value="Cancel"
                                type="button"
                                disabled={loadingTrash}
                                onClick={() => cancelBtnHandler()}
                            >
                                {loadingTrash ? (
                                    <i
                                        className="spinner-border text-primary"
                                        style={{ width: "1em", height: "1em" }}
                                    />
                                ) : (
                                    <FaTrashAlt id={cancelElementIdentifier} />
                                )}
                            </button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default UpdateCampaignPlacementCellRenderer;
